import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startGoogleAuth = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12 bg-[#050507]" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-3 mb-10">
          <div className="w-12 h-12 rounded-full silver-gradient flex items-center justify-center text-[#050507] font-black font-display">555</div>
        </Link>
        <div className="glass rounded-2xl p-8">
          <p className="label-mono mb-3">Sign in</p>
          <h1 className="font-display text-3xl font-light tracking-tighter mb-7">Welcome back.</h1>

          <button onClick={startGoogleAuth} className="w-full mb-5 py-3 rounded-full bg-white text-[#050507] font-bold flex items-center justify-center gap-3 hover:opacity-90 transition" data-testid="google-signin-btn">
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.48 12c0-.73.13-1.44.36-2.1V7.06H2.18A11 11 0 0 0 1 12c0 1.77.43 3.45 1.18 4.94l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.07.56 4.21 1.65l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            Continue with Google
          </button>

          <div className="relative my-5"><div className="border-t border-white/10" /><span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#0A0A0E] px-3 text-[10px] text-gray-500 tracking-widest">OR</span></div>

          <form onSubmit={submit} className="space-y-3">
            <Input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0A0A0E] border-[#1A1A24] h-12 rounded-xl text-white" data-testid="login-email" />
            <Input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0A0A0E] border-[#1A1A24] h-12 rounded-xl text-white" data-testid="login-password" />
            <button type="submit" disabled={busy} className="w-full silver-gradient text-[#050507] font-bold py-3.5 rounded-full disabled:opacity-50" data-testid="login-submit">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-gray-400">
            New here? <Link to="/signup" className="text-white hover:underline" data-testid="login-to-signup">Create account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
